export const ONE_SECOND_IN_MILLISECONDS = 1000;
export const ONE_MINUTE_IN_MILLISECONDS = 60 * ONE_SECOND_IN_MILLISECONDS;
export const ONE_HOUR_IN_MILLISECONDS = 60 * ONE_MINUTE_IN_MILLISECONDS;
export const ONE_DAY_IN_MILLISECONDS = 24 * ONE_HOUR_IN_MILLISECONDS;
export const HALF_HOUR_IN_SECONDS = 30 * ONE_MINUTE_IN_MILLISECONDS / ONE_SECOND_IN_MILLISECONDS;
export const ONE_HOUR_IN_SECONDS = 60 * ONE_MINUTE_IN_MILLISECONDS / ONE_SECOND_IN_MILLISECONDS;
export const HALF_DAY_IN_SECONDS = 12 * ONE_HOUR_IN_MILLISECONDS / ONE_SECOND_IN_MILLISECONDS;
export const ONE_DAY_IN_SECONDS = 24 * ONE_HOUR_IN_MILLISECONDS / ONE_SECOND_IN_MILLISECONDS;
export const ONE_WEEK_IN_SECONDS = 7 * ONE_DAY_IN_MILLISECONDS / ONE_SECOND_IN_MILLISECONDS;
//# sourceMappingURL=constants.time.js.map